/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enum for status of an invoice
 */
export enum InvoiceStatusEnum {
  /**
   * The invoice has been created, sort of a draft. It can be modified and sent later. Initial state.
   */
  DRAFT = "draft",

  /**
   * The invoice is created, and ready to be paid.
   */
  OPEN = "open",

  /**
   * The invoice was payed to the recipient. End State.
   */
  PAID = "paid",

  /**
   * This invoice is cancelled. End State.
   */
  VOIDED = "voided"
}
